module.exports = __webpack_public_path__ + "static/img/backlog2.761bc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/backlog2.png
// module id = zLq3
// module chunks = 83